import { Box, Link, Tab, Tabs } from "@mui/material";
import { CustomChip } from "./CustomChip";
import { OverallProgressFilterObj } from "../../../types";
import { IconButtonOutlined } from "./IconButtonOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../styles/Theme";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "left",
    flexWrap: "nowrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: 0,
    overflow: "auto",
    gap: "24px",
    alignItems: "center",
  },
  tab: {
    opacity: 1,
    minWidth: "0px",
    padding: 0,
    marginRight: "24px",
    "&:hover": {
      boxSizing: "none !important",
      borderBottom: `0px !important`,
      borderTop: `0px !important`,
      backgroundColor: "transparent !important",
    },
  },
  selectedFilterButton: {
    color: theme.palette.text.primary,
    borderRadius: "15px",
    "&:hover": {
      border: `2px solid ${v2theme.palette.primary.main}`,
      transform: "none",
    },
  },
  tabNavigationButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
interface AppliedFilterChipsProps {
  filters: OverallProgressFilterObj[];

  onFilterChange: (filter: OverallProgressFilterObj) => void;
  onFiltersClear: () => void;
}

export const AppliedFilterChips = (props: AppliedFilterChipsProps) => {
  const classes = useStyles();
  const { filters, onFiltersClear, onFilterChange } = props;
  return (
    <>
      <Box className={classes.root}>
        <Tabs
          sx={{
            gap: "24px",
            // [`& .${tabsClasses.root}`]: {
            //     '&.MuiTabs-root': { display: 'hidden' },
            // },
          }}
          ScrollButtonComponent={(props) => {
            if (props.direction === "left" && !props.disabled) {
              return (
                <Box className={classes.tabNavigationButton}>
                  <IconButtonOutlined sx={{ width: "30px", height: "30px" }} {...props}>
                    <ChevronLeftIcon />
                  </IconButtonOutlined>
                </Box>
              );
            } else if (props.direction === "right" && !props.disabled) {
              return (
                <Box className={classes.tabNavigationButton}>
                  <IconButtonOutlined sx={{ width: "30px", height: "30px" }} {...props}>
                    <ChevronRightIcon />
                  </IconButtonOutlined>
                </Box>
              );
            } else {
              return null;
            }
          }}
          variant="scrollable"
          value={false}
          scrollButtons="auto"
          aria-label="scrollable auto tabs example">
          {filters?.map((filter, index) => {
            return (
              <Tab
                key={`${filter}${index}`}
                className={classes.tab}
                label={
                  <CustomChip
                    key={`filter-${filter}`}
                    label={filter.name}
                    onClose={() => {
                      onFilterChange(filter);
                    }}
                  />
                }
              />
            );
          })}
        </Tabs>
        <Link
          sx={{ width: "100px" }}
          onClick={() => {
            onFiltersClear();
          }}
          variant="body1">
          Clear all
        </Link>
      </Box>
    </>
  );
};
